/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import env from '../../../env';
import { Loading, ErrorPopup, usePost } from '../../../components';
import { AdFLStreams } from './AdFLStreams';
import { useAuth } from '../../../auth';

/** productType 4 = Live Feed — used so API returns only live stream products */
const LIVE_FEED_PRODUCT_TYPE = 4;

/** Build map of productId -> watchToken from MyOrders; plus seasonPassToken if user has a season pass. */
function useWatchTokensByProductId() {
  const auth = useAuth();
  const [state, setState] = React.useState({ byProduct: {}, seasonPassToken: null });

  React.useEffect(() => {
    if (!auth.user) {
      setState({ byProduct: {}, seasonPassToken: null });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const token = await auth.user.getIdToken();
        const url = (env.apiBase || '').replace(/\/$/, '') + '/api/order/MyOrders';
        const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok || cancelled) return;
        const orders = await res.json();
        if (!Array.isArray(orders) || cancelled) return;
        const byProduct = {};
        let seasonPassToken = null;
        for (const order of orders) {
          const items = order.orderItems || order.OrderItems || [];
          for (const item of items) {
            const id = item.productId || item.ProductId;
            const watchToken = item.watchToken || item.WatchToken;
            const name = (item.itemName || item.productName || '').toLowerCase();
            const isSeasonPass = /season pass|all season/i.test(name);
            if (id && watchToken) {
              const key = id.toString();
              byProduct[key] = watchToken;
              if (isSeasonPass) seasonPassToken = watchToken;
            }
          }
        }
        if (!cancelled) setState({ byProduct, seasonPassToken });
      } catch (_) {
        if (!cancelled) setState({ byProduct: {}, seasonPassToken: null });
      }
    })();
    return () => { cancelled = true; };
  }, [auth.user]);

  return state;
}

export function LiveStreamListView(props) {
  const { item, cmsOption } = props;
  const post = usePost();
  const { byProduct: watchTokensByProductId, seasonPassToken } = useWatchTokensByProductId();

  React.useEffect(() => {
    post.send(env.apiBase + '/api/product/getProducts', { productType: LIVE_FEED_PRODUCT_TYPE, pageSize: 1000, pageNo: 1 });
    // eslint-disable-next-line
  }, []);

  if (post.loading()) {
    return <Loading />;
  }
  if (post.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={post.errors} />;
  }

  const data = post.response;
  const items = (data && (data.items || data.Items)) || [];

  return (
    <div className="cms_item liveStreamList" data-cms-item-id={cmsOption?.isCmsEdit && item?.itemId} id={item?.anchorName}>
      <AdFLStreams items={items} watchTokensByProductId={watchTokensByProductId} seasonPassToken={seasonPassToken} />
    </div>
  );
}
